export default IconArrowRampLeft3 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-ramp-left-3" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M18 3v6" />
  <path d="M8 16l-4 -4l4 -4" />
  <path d="M18 21v-6a3 3 0 0 0 -3 -3h-11" />
</svg>`;